import { Feedback, ModalContainer, Spinner } from '@welbe/web-design-system';
import { ReactComponent as CampaignIcon } from 'App/assets/img/campaigns_variant.svg';
import CheckCampaign from 'App/assets/img/checklist-icon-big.png';
import { ReactComponent as SadFaceIcon } from 'App/assets/img/sad-face.svg';
import React from 'react';
import { IntroTutorial } from '../../App/Components/IntroTutorial/IntroTutorial';
import { ModalNotAuthorized } from '../../App/Components/ModalNotAuthorized/ModalNotAuthorized';
import { CompaignsContent } from './Campaigns.content';
import { CampaignsEmpty } from './Campaigns.empty';
import { useCampaigns } from './Campaigns.hooks';
import { CampaignsSkeleton } from './Campaigns.skeleton';
import { ContainerLoading, LayoutPage } from './Campaigns.styles';
import { NewCampaignSettingsModal } from './components/NewCampaignSettingsModal/NewCampaignSettingsModal';
import { tutorialCampaignSteps } from './constants/tutorialCampaignSteps';

export const Campaigns = (): JSX.Element => {
	const {
		isLoading,
		campaigns,
		campaignSettings,
		isModalOpen,
		isLoadingCampaigns,
		showModalCampaignNotAuthorized,
		hasError,
		isSettingsModalOpen,
		handleNewSettingsModal,
		setShowModalCampaignNotAuthorized,
		setSettingsModalOpen,
		handleNewCampaign,
		handleEditCampaign,
		handleSubmitNewCampaign,
		onRetry,
	} = useCampaigns();

	const FeedbackElement = (): JSX.Element => (
		<Feedback
			childrenButton="Recargar Contenido"
			message="Hubo un error al cargar el contenido."
			onRetry={onRetry}
			Icon={SadFaceIcon}
		/>
	);

	const getCampaignsComponent = () => {
		if (isLoading) {
			return CampaignsSkeleton;
		}

		if (hasError) {
			return FeedbackElement;
		}

		if (!campaigns.length) {
			return CampaignsEmpty;
		}

		return CompaignsContent;
	};

	const CampaignsComponent = getCampaignsComponent();

	return (
		<React.Fragment>
			<LayoutPage>
				{showModalCampaignNotAuthorized && (
					<ModalNotAuthorized
						title="Campañas NOM - 035"
						message="Evalua factores de riesgo psicosocial en tu empresa"
						imageUrl={CheckCampaign}
						onClose={() => setShowModalCampaignNotAuthorized(false)}
					/>
				)}
				<CampaignsComponent
					campaigns={campaigns}
					onCreateNewCampaign={handleNewCampaign}
					onEditCampaign={handleEditCampaign}
				/>
			</LayoutPage>

			<ModalContainer
				visible={isSettingsModalOpen}
				height="650px"
				width="370px"
				padding="20px"
				closeOnlyOnTheButton
				headerIcon={<CampaignIcon />}
			>
				{isLoadingCampaigns ? (
					<ContainerLoading>
						<Spinner size="24px" />
					</ContainerLoading>
				) : (
					<NewCampaignSettingsModal
						items={campaignSettings}
						onClose={() => setSettingsModalOpen(false)}
						onContinue={handleSubmitNewCampaign}
					/>
				)}
			</ModalContainer>

			{isModalOpen && (
				<IntroTutorial
					context="campaign"
					height="655px"
					items={tutorialCampaignSteps}
					onFinish={handleNewSettingsModal}
				/>
			)}
		</React.Fragment>
	);
};
